module.exports = __webpack_public_path__ + "img/lets-intro-logo (2).721d9379.png";